import { render, staticRenderFns } from "./AttendanceRatio.vue?vue&type=template&id=0b2bc699&scoped=true&"
import script from "./AttendanceRatio.vue?vue&type=script&lang=js&"
export * from "./AttendanceRatio.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceRatio.vue?vue&type=style&index=0&id=0b2bc699&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2bc699",
  null
  
)

export default component.exports